import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import { getLabelPadding } from '@wix/editor-elements-common-utils';
import type {
  SelectionTagsListDefinition,
  ISelectionTagsListMapperProps,
  SelectionTagsListCSSVars,
  SelectionTagsListCssCarmiData,
  SelectionTagsListAlignmentProps,
} from '../SelectionTagsList.types';

export const props = withCompInfo<
  ISelectionTagsListMapperProps,
  SelectionTagsListDefinition
>()(['compData', 'compProps'], ({ compData, compProps }) => {
  const { isDisabled, required, label } = compProps;
  const { options, value } = compData;

  return { options, value, isDisabled, required, label };
});

export const css = withCompInfo<
  SelectionTagsListCSSVars,
  SelectionTagsListDefinition,
  SelectionTagsListCssCarmiData
>()(
  ['compProps', 'compLayout', 'hasResponsiveLayout', 'isOneDocMigrated'],
  (
    { compProps, compLayout, hasResponsiveLayout, isOneDocMigrated },
    carmiProps,
  ) => {
    const { direction, labelMargin, hasAutoHeight } = compProps;

    let alignment: string = compProps.alignment;

    if (compProps.alignment === 'left') {
      if (direction === 'rtl') {
        alignment = 'flex-end';
      } else {
        alignment = 'flex-start';
      }
    } else if (compProps.alignment === 'right') {
      if (direction === 'rtl') {
        alignment = 'flex-start';
      } else {
        alignment = 'flex-end';
      }
    }

    const heightAutoCss =
      hasAutoHeight || !isOneDocMigrated ? { height: 'auto' as const } : {};

    const minHeightCss =
      hasResponsiveLayout || hasAutoHeight || isOneDocMigrated
        ? {}
        : {
            'min-height': `${compLayout.height}px`,
          };

    return {
      '--textAlign': compProps.alignment,
      '--labelDir': compProps.alignment === 'right' ? 'rtl' : 'ltr',
      '--direction': direction,
      '--alignment': alignment as SelectionTagsListAlignmentProps,
      '--fnt': carmiProps['--fnt'],
      '--labelPadding': getLabelPadding(compProps),
      '--labelMarginBottom': `${labelMargin}px`,
      ...heightAutoCss,
      ...minHeightCss,
    };
  },
);

export const stateRefs = withStateRefsValues(['experiments']);

export default createComponentMapperModel({
  props,
  css: css as any,
  stateRefs,
});
